import Vue from 'vue';

export default {
	set(obj, key, value) {
		!Object.prototype.hasOwnProperty.call(obj, key) ? Vue.set(obj, key, value) : obj[key] = value;
	}
}